import gql from 'graphql-tag';

export const getHeaders = () => {
  return [ 
    { text: 'ID', value: 'id' },
    { text: 'Nombre', value: 'nombre' },
    { text: 'Color', value: 'color' },
    { text: 'Estado', value: 'estado' }, 
    { text: '', value: 'actions', width:'180px' }, 
  ]
}

export const getDatos = async () => { 
  return []
}

export const cambiarEstado = async (vue,tituloid, estado) => { 
  const res = vue.$apollo.query({ query: gql`mutation{cambiarEstadoEstadoTitulacion(input:{id:${tituloid},estado:${estado}}){ok,errors{message}}}` }).then(({ data: { cambiarEstadoEstadoTitulacion } }) => {return cambiarEstadoEstadoTitulacion}).catch((error) => error);
  return res;
}

export const createEstadoTitulacion = async (vue,nombre, color) => { 
  const res = vue.$apollo.query({ query: gql`mutation{createEstadoTitulacion(input:{nombre:"${nombre}",color:"${color}"}){ok,errors{message}}}` }).then(({ data: { createEstadoTitulacion } }) => {return createEstadoTitulacion}).catch((error) => error);
  return res;
}

export const updateEstadoTitulacion = async (vue,nombre, color, id) => { 
  const res = vue.$apollo.query({ query: gql`mutation{updateEstadoTitulacion(input:{id:${id},nombre:"${nombre}",color:"${color}"}){ok,errors{message}}}` }).then(({ data: { updateEstadoTitulacion } }) => {return updateEstadoTitulacion}).catch((error) => error);
  return res;
}
